import FormsInputMaterial from "@olmokit/core/forms/input/material";
import FormsSelectMaterial from "@olmokit/core/forms/select/material";
import "@olmokit/core/forms/checkbox";
import FormsTextareaMaterial from "@olmokit/core/forms/textarea/material";
import Olmoforms from "@olmokit/core/olmoforms/feedback";
import Dependency from "@olmokit/core/olmoforms/dependency";
import { $, $all, addClass, on, removeClass } from "@olmokit/dom";
import { post } from "@olmokit/core/fragments/ajax";
import { FormProductDetail } from "./ProductDetail";
import { FormProductProps } from "components/Form/ProductDetail/Property";
import { globalConf } from "@olmokit/core/data";
import { countryEndpoint, hideProject, showProject } from "components/Form";
import axios from 'axios';
import { dataLayerFillingForm, dataLayerForm } from "components/Datalayer";
import { salesforceCommunication } from "components/Form";
import "./Product.scss";

/**
 * Component: FormProductCart
 */

let counter = 0;
let olmoforms;

export function FormProduct() {
  console.log("FormProduct mounted.");

  dataLayerFillingForm('#contact .of:el', 'Form Product')

  const $container = $('.FormProduct: .of:country');
  const $country = $('select', $container);

  on($country, 'change', () => {
    countryEndpoint(".FormProduct:", $country.value);
  });

  const $jobcontainer = $('.FormProduct: .of:job');
  const $jobfield = $('select', $jobcontainer);
  const $projcontainer = $('.FormProduct: .of:project');
  const $projfield = $('select', $projcontainer);
  const $mqcontainer = $('.FormProduct: .of:projectmq');
  const $yearcontainer = $('.FormProduct: .of:projectyear');

  on($jobfield, 'change', () => {
    if ($jobfield.value == 'Press Stampa') {
      hideProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
    } else {
      $projcontainer.style.display = 'block';
      showProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
    }
  });
  on($projfield, 'change', () => {
    showProject($projcontainer, $projfield, $mqcontainer, $yearcontainer);
  })

  let ip = '';

  olmoforms = Olmoforms(".FormProduct:", {
    before: async (formData) => {
      console.log('step 1');
      console.log(formData);

      const $localcheck = $('#of-9-localcheck');
      if ($localcheck.value !== '') {
        console.log('stopped');
        olmoforms.boot(); // Halts submission
        return Promise.reject("Local check failed");
      }

      try {
        console.log('detectip');
        const { data } = await post('detectip', {
          data: { item: '$minimal' }
        });
        console.log('step 2');        
        ip = data;

        const token = await grecaptcha.execute('6Lf-wxorAAAAAIdTqMQ_Ah0OHludYUF6ga-iDaPC', { action: 'submit' });
        console.log('step 3');

        await axios.post(globalConf.cmsApiUrl + '/recaptcha', {
          token,
          ip,
        });

        console.log('step 4');
        console.log('recaptcha done');
      } catch (error) {
        console.error('step ERROR', error);
        olmoforms.boot(); // Prevents submit if reCAPTCHA or detectip fails
        return Promise.reject("Hook before failed");
      }

      console.log('step 5 (end)');

    },   
    sent: (response) => {
      const { data, formData } = response;
      dataLayerForm("form sent", data.form.body, "Form Product", $('#of-3-usertype').value, $('#of-3-requesttype').value);
      console.log('sent', formData);
      console.log('step 6');

      axios.post(globalConf.cmsApiUrl + '/formscompiler', {
        email: formData['email'],
        ip: ip,
      })
        .then(() => {
          console.log('step 7');
          console.log('formscompiler done');
        })
        .catch((error) => {
          console.log(error);
        });

      salesforceCommunication(data.form.body, "Form Product");
    },
    failed: (instance) => dataLayerForm("form_error", '', "Form Product", $('#of-3-usertype').value, $('#of-3-requesttype').value)
  });

  FormsInputMaterial();
  Dependency(".FormProduct:");
  FormsSelectMaterial();
  FormsTextareaMaterial();


  FormProductDetail();

  const $product = $('#of-9-product');
  on($product, 'change', (event) => {
    debugger;
    makeThePostParams(0, event.target.value);
    FormsSelectMaterial();
    const $productInput = $('#of-9-products');
    let array = [];
    let obj = {
      product: event.target.value
    };
    array.push(obj);
    $productInput.value = JSON.stringify(array);
  });

  // makeThePost(); 

  return {
    destroy() {
      olmoforms.destroy();
    },
  };
}

export function makeThePostParams(index, name) {
  post('productpropform', {
    data: {
      id: index,
      name: name
    },
  }).then(({ data }) => {
    // const $productpros = $('.FormProductDetail:property'+index);
    const $productpros = $('.of:productspace');
    $productpros.innerHTML = data;
    FormProductProps();
  });

}

export function makeThePost() {
  post('productform', {
    data: {
      id: counter
    },
  }).then(({ data }) => {
    const detail = $('.productCoutnauner');
    if (detail) {

      const productDetails = $all('.productCoutnauner');
      let container = document.createElement("div");
      addClass(container, 'productCoutnauner');
      productDetails[productDetails.length - 1].after(container);
      const productDetailsNew = $all('.productCoutnauner');
      productDetailsNew[productDetails.length].innerHTML = data;

    } else {

      const $productspace = $('.of:productspace');
      let container = document.createElement("div");
      addClass(container, 'productCoutnauner');
      $productspace.appendChild(container);
      const $productCoutnauner = $('.productCoutnauner');
      $productCoutnauner.innerHTML = data;

    }
    FormProductDetail();
  });

  counter++;
} 